'use client'

import FormsAndAppendices from './FormsAndAppendices'
import InfoItem from './InfoItem'
import RatesCharges from './RatesCharges'
import ShariahItem from './ShariahItem'

export { InfoItem, ShariahItem, RatesCharges, FormsAndAppendices }
export type { RatesChargesItem } from './RatesCharges'
export type { FormButton } from './FormsAndAppendices'
